import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { MeasureSolutionBody } from '@e-origin/contracts';

import { apiClient } from '@utils';
import { MEASURE_SOLUTIONS_QUERY_KEY } from './useMeasureSolutions';

export const useCreateMeasureSolution = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: MeasureSolutionBody) => {
      const result = await apiClient.measureSolutions.createMeasureSolution.mutation({ body });
      if (result.status !== 201) {
        throw result.body;
      }
      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEASURE_SOLUTIONS_QUERY_KEY] });
      toast.success('Measure solution created successfully!');
    },
  });
};
